import { useLocation, useNavigate } from 'react-router-dom';
import { TABS } from '../constants';

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.slice(1) || 'people';

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 lovi-glass-nav border-t border-edge/50"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex items-center justify-around pt-2 pb-1 max-w-2xl mx-auto px-2">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(`/${tab.id}`)}
              className={`flex flex-col items-center justify-center flex-1 h-full py-2 transition-all active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:rounded-lg ${
                isActive ? 'text-ink' : 'text-ink-tertiary hover:text-ink-secondary'
              }`}
              aria-current={isActive ? 'page' : undefined}
              aria-label={tab.label}
            >
              <span
                className={`material-icons-round text-xl ${
                  isActive ? 'scale-110' : ''
                } transition-transform`}
              >
                {tab.icon}
              </span>
              <span className={`text-xs mt-0.5 ${isActive ? 'font-bold' : 'font-medium'}`} data-ph-no-mask>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
      {/* iOS Home Indicator */}
      <div className="flex justify-center pb-2">
        <div className="w-32 h-1 bg-ink-tertiary rounded-full" aria-hidden="true" />
      </div>
    </nav>
  );
}

export default BottomNav;
